/**
 * @generated SignedSource<<1a514e8d794c9ecdfbc3e9027c7b362f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type adminDashboard_WaitlistQuery$variables = Record<PropertyKey, never>;
export type adminDashboard_WaitlistQuery$data = {
  readonly adminWaitlist: ReadonlyArray<{
    readonly attribution: {
      readonly landing: string | null | undefined;
      readonly page: string | null | undefined;
      readonly ref: string | null | undefined;
      readonly referrer: string | null | undefined;
      readonly utmCampaign: string | null | undefined;
      readonly utmContent: string | null | undefined;
      readonly utmMedium: string | null | undefined;
      readonly utmSource: string | null | undefined;
    } | null | undefined;
    readonly completenessScore: number;
    readonly createdAt: string;
    readonly email: string;
    readonly files: ReadonlyArray<{
      readonly byteSize: number | null | undefined;
      readonly detectedIncome: number;
      readonly filename: string | null | undefined;
      readonly id: string;
      readonly parseState: string;
      readonly txnCount: number;
    }>;
    readonly fitScore: number;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly referralBonus: number;
    readonly referralCode: string | null | undefined;
    readonly referredByEmail: string | null | undefined;
    readonly scoreBreakdown: ReadonlyArray<{
      readonly max: number;
      readonly name: string;
      readonly points: number;
    }>;
    readonly status: string;
  }>;
};
export type adminDashboard_WaitlistQuery = {
  response: adminDashboard_WaitlistQuery$data;
  variables: adminDashboard_WaitlistQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminWaitlistEntry",
    "kind": "LinkedField",
    "name": "adminWaitlist",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referredByEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fitScore",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralBonus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completenessScore",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LeadScoreDimension",
        "kind": "LinkedField",
        "name": "scoreBreakdown",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "points",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "max",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OnboardingUploadedFile",
        "kind": "LinkedField",
        "name": "files",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "byteSize",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "txnCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "detectedIncome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parseState",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LeadAttribution",
        "kind": "LinkedField",
        "name": "attribution",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "page",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "utmSource",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "utmMedium",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "utmCampaign",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "utmContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "landing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ref",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "referrer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "adminDashboard_WaitlistQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "adminDashboard_WaitlistQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c6f396791d0b0f6803e8e8bd41e3f652",
    "id": null,
    "metadata": {},
    "name": "adminDashboard_WaitlistQuery",
    "operationKind": "query",
    "text": "query adminDashboard_WaitlistQuery {\n  adminWaitlist {\n    id\n    email\n    name\n    referralCode\n    referredByEmail\n    createdAt\n    status\n    fitScore\n    referralBonus\n    completenessScore\n    scoreBreakdown {\n      name\n      points\n      max\n    }\n    files {\n      id\n      filename\n      byteSize\n      txnCount\n      detectedIncome\n      parseState\n    }\n    attribution {\n      page\n      utmSource\n      utmMedium\n      utmCampaign\n      utmContent\n      landing\n      ref\n      referrer\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c89f9aaf84aa0fde61d0802414ff124";

export default node;
